import React, { Fragment } from "react";
import { TyNavMenuMap } from "../../../../../types";
import MenuItem from "./menu-item";
import QuickLink from "../../../../basic/quickLink";
import { buildAnalytics, DataAnalyticsLocations, DataAnalyticsTypes } from "../../../../basic/analytics";

interface NavMenuProps {
  navigationMap: TyNavMenuMap;
}

export default function NavMenu({ navigationMap }: NavMenuProps): JSX.Element {
  
  return (
    <div className="flex flex-col bg-[#E6F2F7]">
      {Object.keys(navigationMap).map((name:any, idx) => (
        <div key={`hd-mb-nmd-${idx}`} className="flex flex-col mx-4">
           <Fragment key={idx}>
           {Array.isArray(navigationMap[name]) && navigationMap[name].map((item: any, li: any) => (
              <Fragment key={li}>
                 {item.menu === true && ( 
                  <MenuItem name={name} linkMap={item.data} /> 
                 )}
                  {item.menu === false && ( 
                    <QuickLink
                      href={item?.data?.href}
                      className="flex text-sm hover:text-secondary-300 py-sm font-medium border-b-4 border-transparent text-inky"
                      dataAnalytics={buildAnalytics(DataAnalyticsLocations.Slider, DataAnalyticsTypes.Link,
                      [DataAnalyticsLocations.Page,DataAnalyticsLocations.Header,DataAnalyticsLocations.Menu ])} isExternal={item?.data?.isexternallink}>
                      {item?.data?.label}
                    </QuickLink>
                  )}
              </Fragment>
           ))}
           </Fragment>
        </div>
      ))}
    </div>
  );
}
